import { Component } from "preact";
import PropTypes from "prop-types";
import { combineClasses, get } from "@green24/npm-javascript-utils";
import { E_RentWizard_Section } from "../../models/constants/Enums_RentWizard";
import RentSelectionPage from "./sections/RentWizardTariff";
import RentWizardContact from "./sections/RentWizardContact";
import RentWizardPinVerification from "./sections/RentWizardPinVerification";
import PathRestricted from "../../components/shared/PathRestricted";
import { E_Route } from "../../models/constants/Enum_Routes";
import RentWizardPayment from "./sections/RentWizardPayment";
import { sessionServices } from "../../services/session-services";
import { E_Session_PaymentState } from "../../models/constants/Enums_Session";
import { CurrencyProvider, Redirect } from "../../components/components";

class RentWizard extends Component {
	constructor() {
		super();

		this.state = {
			data: {
				bracketID: null,
				serviceTypeID: null,
			},
			session: null,
		}
	}

	componentWillUnmount() {
		const {session} = this.state;

		if(session && session.id && session.id > 0 && [E_Session_PaymentState.PENDING].includes(session.paymentState)) {
			sessionServices.deleteItem(session.id);
		}
	}

	_renderSection() {
		const {section} = this.props;
		const {data, session} = this.state;

		switch (section) {
			case E_RentWizard_Section.CONTACT:
				return <RentWizardContact
					serviceTypeID={data.serviceTypeID}
					bracketID={data.bracketID}

					onSession={session => this.setState({session})}
				/>;
			case E_RentWizard_Section.PAYMENT:
				return <RentWizardPayment
					serviceTypeID={data.serviceTypeID}
					bracketID={data.bracketID}
					session={session}
					onSession={session => this.setState({session})}
				/>;
			case E_RentWizard_Section.PIN_TEST:
				return <RentWizardPinVerification
					session={session}
					onSessionCancelled={() => this.setState({session: null})}
				/>;
			case E_RentWizard_Section.TARIFF_SELECTION:
			default:
				return <RentSelectionPage
					bracketID={data.bracketID}
					serviceTypeID={data.serviceTypeID}

					onBracketSelected={(id) => this._updateData({bracketID: id})}
					onTypeSelected={(id) => this._updateData({serviceTypeID: id})}
				/>;
		}
	}

	render({className, style}, {data, session}) {
		return (
			<section className={combineClasses("rent-wizard", className)} style={style}>
				{
					!data.bracketID &&
					<PathRestricted blacklist={[E_Route.RENT_WIZARD(E_RentWizard_Section.TARIFF_SELECTION)]}>
						<Redirect to={E_Route.RENT_WIZARD(E_RentWizard_Section.TARIFF_SELECTION)}/>
					</PathRestricted>
				}

				<CurrencyProvider currency={get(session, "tariff.currency")}>
					{this._renderSection()}
				</CurrencyProvider>
			</section>
		);
	}

	_updateData(partialData) {
		this.setState(state => {
			return {
				data: {
					...state.data,
					...partialData,
				},
			}
		});
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			section: PropTypes.oneOf(Object.values(E_RentWizard_Section)),
		}
	}

	static get stateTypes() {
		return {
			data: PropTypes.object,
		}
	}

	static get defaultProps() {
		return {
			section: E_RentWizard_Section.TARIFF_SELECTION,
		}
	}
}

export default RentWizard;
